import { useCallback, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import intl from 'react-intl-universal';

import { alertAction } from '../thunks/Alerts';
import { selectUserProfile } from '../ducks/Auth';
import { selectSubscribers, selectRequested } from '../ducks/Subscribers';
import * as subscriberActions from '../thunks/Subscribers';
import Subscription from './Subscription';
import { useParams } from 'react-router-dom';

const mapStateToProps = () =>
  createStructuredSelector({
    user: selectUserProfile(),
    subscribers: selectSubscribers(),
    requested: selectRequested(),
  });

const mapDispatchToProps = (dispatch: any) => bindActionCreators({ ...subscriberActions }, dispatch);

const SubscriptionContainer = ({ id, user, subscribers, requested, fetchSubscribers, unsubscribe, subscribe }: any) => {
  const { communityId, roomId, boardId } = useParams();

  const handleFetchSubscribers = useCallback(
    () =>
      fetchSubscribers({ communityId, roomId, boardId, id }).then((action: any) =>
        alertAction({ action, error: intl.get('subscription.fetch.error') }),
      ),
    [communityId, roomId, boardId, id, fetchSubscribers],
  );

  useEffect(() => {
    if (requested.id !== id) {
      handleFetchSubscribers();
    }
  }, [id, requested, handleFetchSubscribers]);

  const isSubscribing = () =>
    subscribers && subscribers.some((subscriber: any) => subscriber.id === user.id.split('@')[0].replace('~', '@'));

  const handleSubscribe = () => {
    const subscribing = isSubscribing();

    if (subscribing) {
      unsubscribe({ communityId, roomId, boardId, id }).then((action: any) =>
        alertAction({
          action,
          error: intl.get('subscription.unsubscribe.error'),
          onSuccess: () => handleFetchSubscribers(),
        }),
      );
    } else {
      subscribe({ communityId, roomId, boardId, id }).then((action: any) =>
        alertAction({
          action,
          success: intl.get('subscription.subscribe.success'),
          error: intl.get('subscription.subscribe.error'),
          onSuccess: () => handleFetchSubscribers(),
        }),
      );
    }
  };

  if (!id) {
    return <div />;
  }

  return <Subscription id={id} isSubscribing={isSubscribing()} onSubscribe={handleSubscribe} />;
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionContainer);
